import {
    global,
    lazyloader,
    hero,
    pillars,
    stats,
    nav,
    map,
    testimonials,
    download,
    video,
    brandslider,
    dashboard,
    dealerNav,
    sidecart,
    portalSlider,
    orderBuilder,
    orderBuilder2,
    footer,
    industry,
    infoSlider,
    warrantyApp,
    warrantyViewAll,
    shipAndBilling,
    review,
    login,
    cart,
    orderDetails,
    orderConfirmation,
    paginationList,
    statementsAndBilling,
    payments,
    orderHistory,
    backorders,
    invoiceHistory,
    training,
    forgot,
    register,
    myAccount,
    changePW,
    educationEvents,
    documentList,
    uploadOrder,
    modal,
    user,
    contact,
    career,
    datePicker,
    dailyPromo,
    statusBar,
    fiddle,
    registeredEvents,
    autoComplete,
    products,
    loadParts,
    loginasdealer,
    partSmart,
} from 'js';

const modules = [
    {
        module: lazyloader,
        el: '.lazyload',
    },
    {
        module: hero,
        el: '.hero',
    },
    {
        module: pillars,
        el: '.pillars',
    },
    {
        module: stats,
        el: '.stats',
    },
    {
        module: nav,
        el: '.nav',
    },
    {
        module: map,
        el: '.map',
    },
    {
        module: testimonials,
        el: '.tm',
    },
    {
        module: download,
        el: '.dl',
    },
    {
        module: video,
        el: '.cta-video',
    },
    {
        module: brandslider,
        el: '.brand-slider',
    },
    {
        module: dashboard,
        el: '.db',
    },
    {
        module: dealerNav,
        el: '.db-nav',
    },
    {
        module: sidecart,
        el: '.sidecart',
        disableif: '[disable-sidecart]',
    },
    {
        module: portalSlider,
        el: '.portal-slider',
    },
    // {
    //   module: orderBuilder,
    //   el: '.js--ob',
    // },
    // {
    //   module: orderBuilder2,
    //   el: 'order-builder-search',
    // },
    {
        module: footer,
        el: '.js--footer-bc',
    },
    {
        module: industry,
        el: '.industry',
    },
    {
        module: infoSlider,
        el: '.infoslider',
    },
    {
        module: warrantyApp,
        el: '#warranty_app',
    },
    {
        module: warrantyViewAll,
        el: '.js--warranty-view-all',
    },
    {
        module: shipAndBilling,
        el: '.js--ship-and-billing',
    },
    {
        module: review,
        el: '.js--review',
    },
    {
        module: login,
        el: '.js--login-main',
    },
    {
        module: cart,
        el: '.js--checkout-list-products',
    },
    {
        module: orderConfirmation,
        el: '.js--order-confirmation',
    },
    {
        module: paginationList,
        el: '.js--pagination-list, .js--pagedDocumentList',
    },
    {
        module: statementsAndBilling,
        el: '.js--sh',
    },
    {
        module: payments,
        el: '.js--payments',
    },
    {
        module: orderHistory,
        el: '.js--oh-mini',
    },
    {
        module: training,
        el: '.js--training',
    },
    {
        module: forgot,
        el: '.js--login-forgot',
    },
    {
        module: register,
        el: '.js--register',
    },
    {
        module: myAccount,
        el: '.js--account',
    },
    {
        module: changePW,
        el: '.js--changepw',
    },
    {
        module: orderDetails,
        el: '#order-details',
    },
    {
        module: uploadOrder,
        el: '.js--upload-order',
    },
    {
        module: modal,
        el: '.js--pd-modal',
    },
    {
        module: user,
        el: '.js--db-content',
    },
    {
        module: contact,
        el: '.js--contact-public',
    },
    {
        module: career,
        el: '.js--career',
    },
    {
        module: datePicker,
        el: '.pd-date',
    },
    {
        module: dailyPromo,
        el: '.js--daily-promo',
    },
    {
        module: statusBar,
        el: '.alert-bar',
    },
    {
        module: global,
    },
    {
        module: fiddle,
        el: '.fiddle',
    },
    {
        module: registeredEvents,
        el: '.js--registered-events',
    },
    {
        module: documentList,
        el: '.js--pagedDocumentList',
    },
    {
        module: loadParts,
        el: '.multiple__products',
    },
    {
        module: products,
        el: '.js-card-single',
    },
    {
        module: loginasdealer,
        el: '.js--login-as-dealer',
    },
    {
        module: partSmart,
        el: '.js--partsmart'
    }
];

export default modules;



// WEBPACK FOOTER //
// ./app/js/config.js